// Oct 31 2026 · SEO audit — titles/descriptions for public pages that had NO
// metadata of their own (they inherited the homepage title). Rendered at
// runtime by DefaultSEO when no page-level <SEO> owns the head, and baked into
// the static HTML by scripts/bake-seo-heads.js. Keep ≤60 chars titles where
// possible, ≤160 chars descriptions. Target phrase in [brackets] for reference.
export const SEO_ROUTES = {
  "/": {
    description: "Botox, dermal and lip fillers, Sculptra, HydraFacial Syndeo, IPL and laser by Karine Lauzon RN and team. Three clinics: Ottawa, Kanata, Carleton Place. Book online 24/7 — try FacialVisionAI, our AI aesthetic mirror.",
  },
  "/menu": {
    title: "Treatment Menu & Prices | Karine Lauzon RN Clinics Ottawa",
    description: "Every treatment and fixed price in one place — Botox, fillers, Sculptra, skin boosters, HydraFacial, IPL, laser and facials across Ottawa, Kanata and Carleton Place.",
  },
  "/book": {
    title: "Book Online — Botox, Fillers, HydraFacial | Ottawa, Kanata, Carleton Place",
    description: "Pick your treatment, clinic and time in under a minute. Live availability for Ottawa, Kanata and Carleton Place with Karine Lauzon RN and team.",
  },
  "/rewards": {
    title: "Crown Rewards Loyalty Program | Karine Lauzon RN Clinics",
    description: "Earn Crown points on every Botox, filler, HydraFacial and skincare purchase, refer friends and redeem at any of our Ottawa, Kanata or Carleton Place clinics.",
  },
  "/referral": {
    title: "Refer a Friend — Earn Crown Rewards | Karine Lauzon RN Clinics",
    description: "Invite friends and family to Karine Lauzon RN Clinics. You earn 1,000 Crown points when they complete a first visit; they get 500 to start.",
  },
  "/promo/laser-genesis-lymphatic": {
    title: "Laser Genesis + Lymphatic Drainage Promo | Ottawa — Karine Lauzon RN",
    description: "Ottawa promotion: Laser Genesis collagen stimulation paired with facial lymphatic drainage in one visit. Fixed price, performed by our medical aesthetician.",
  },
  "/promo/glow-reset": {
    title: "Glow Reset Promotion | HydraFacial & Skin Treatments Ottawa",
    description: "Seasonal Glow Reset offer at our Ottawa clinic — HydraFacial, LED and skin boosters bundled at a fixed price. Limited-time, book online.",
  },
  "/laser-hair-removal": {
    title: "Laser Hair Removal Ottawa — Any 3 Areas $99 | Karine Lauzon RN Clinics",
    description: "Medical-grade laser hair removal at our Ottawa clinic on Prince of Wales Drive. Fixed prices per area, Any 3 Areas for $99, packages that save. Book online.",
  }, // [laser hair removal Ottawa]
  "/laser-hair-removal-ottawa": {
    title: "Laser Hair Removal in Ottawa | Prices by Area — Karine Lauzon RN",
    description: "Laser hair removal in Ottawa with our medical aesthetician: upper lip, underarms, Brazilian, legs, back and more at fixed prices. Free parking, book online.",
  },
  "/radiesse": {
    title: "Radiesse Ottawa — Collagen Biostimulator for Hands, Neck & Face",
    description: "Radiesse calcium hydroxylapatite treatments in Ottawa, Kanata and Carleton Place with Karine Lauzon RN: hands, neck and décolleté, jawline. Fixed pricing.",
  },
  "/tanya-jackson": {
    title: "Tanya Jackson, Medical Aesthetician — HydraFacial, Laser & IPL Ottawa",
    description: "Meet Tanya Jackson, medical aesthetician at our Ottawa clinic: HydraFacial Syndeo, Cynosure Icon MaxG IPL, Laser Genesis, laser hair removal and Éminence facials.",
  },
  "/skin-booster-ottawa": {
    title: "Skin Boosters Ottawa — Redensity 1 & Hydration Injectables | Karine Lauzon RN",
    description: "Redensity 1 and hyaluronic skin boosters in Ottawa, Kanata and Carleton Place for glow, hydration and fine lines. Performed by Karine Lauzon RN. Fixed prices.",
  },
  "/dermal-fillers": {
    title: "Dermal Fillers Ottawa, Kanata & Carleton Place | Karine Lauzon RN",
    description: "Cheeks, lips, chin, jawline and under-eye dermal fillers by Karine Lauzon RN. 18 transparent packages, fixed prices, three clinics. Free assessment with every visit.",
  }, // [dermal fillers Kanata]
  "/sculptra": {
    title: "Sculptra Ottawa — Collagen Restoration | Karine Lauzon RN Clinics",
    description: "Sculptra poly-L-lactic acid treatments in Ottawa, Kanata and Carleton Place. Gradual, natural volume over three months. Series pricing, Karine Lauzon RN.",
  }, // [Sculptra Ottawa]
  "/lip-filler-ottawa": {
    title: "Lip Fillers Ottawa — ½ to 2 Syringes, Fixed Prices | Karine Lauzon RN",
    description: "Natural lip filler in Ottawa, Kanata and Carleton Place: ½ syringe $299 with a free Lip Flip, 1 syringe $499, 2 syringes $950. Karine Lauzon RN, 35+ years.",
  }, // [lip fillers Ottawa]
  "/microneedling-ottawa": {
    title: "RF Microneedling Ottawa — Tighten, Refine, Rebuild | Karine Lauzon RN",
    description: "Radiofrequency microneedling at our Ottawa clinic for texture, laxity and acne scars. Face, neck and décolleté protocols at fixed prices.",
  }, // [microneedling Ottawa]
  "/medical-microneedling": {
    title: "Medical Microneedling Ottawa | Collagen Induction — Karine Lauzon RN",
    description: "Medical-grade microneedling and RF microneedling in Ottawa for fine lines, scars and pores. Performed by trained clinicians with medical aftercare.",
  },
  "/prp-ottawa": {
    title: "PRP Therapy Ottawa — Face & Hair Restoration | Karine Lauzon RN",
    description: "Platelet-rich plasma facials and PRP hair restoration in Ottawa using your own growth factors. Microneedling + PRP from $750. Karine Lauzon RN Clinics.",
  },
  "/before-after": {
    title: "Before & After Results — Botox, Fillers, Skin | Karine Lauzon RN",
    description: "Real client results from Karine Lauzon RN Clinics in Ottawa, Kanata and Carleton Place: Botox, lip and dermal fillers, Sculptra, skin boosters and HydraFacial.",
  },
  "/faq": {
    title: "FAQ — Botox, Fillers, Booking & Pricing | Karine Lauzon RN Clinics",
    description: "Answers about Botox units, filler longevity, HydraFacial, pricing, payment plans, Crown Rewards and booking at our Ottawa, Kanata and Carleton Place clinics.",
  },
  "/team": {
    title: "Our Team — Karine Lauzon RN, Tanya Jackson & Linda Lafrance NP",
    description: "Meet the clinicians behind Karine Lauzon RN Clinics: Karine Lauzon RN (injector), Tanya Jackson (medical aesthetician) and Linda Lafrance MScN, NP.",
  },
  "/aftercare": {
    title: "Treatment Aftercare Guides — Botox, Fillers, Laser | Karine Lauzon RN",
    description: "Nurse-written aftercare for Botox, dermal fillers, Sculptra, HydraFacial, IPL and laser so your results settle beautifully. Ottawa, Kanata, Carleton Place.",
  },
  "/fr/botox-ottawa": {
    title: "Botox Ottawa — Infirmière injectrice, 35 ans d'expérience | Karine Lauzon inf.",
    description: "Botox et neuromodulateurs à Ottawa, Kanata et Carleton Place par Karine Lauzon, infirmière autorisée. Prix fixes par zone, évaluation gratuite, réservation en ligne.",
  },
  "/treatments": {
    description: "Explore every treatment family at Karine Lauzon RN Clinics — injectables, skin boosters, HydraFacial, IPL, laser and facials — with fixed prices and online booking.",
  },
  "/laser-and-skin": {
    description: "Laser Genesis, RF microneedling, dermaplaning, lymphatic drainage and facials at our Ottawa clinic with medical aesthetician Tanya Jackson. Fixed prices, book online.",
  },
  "/chemical-peels": {
    title: "Chemical Peels Ottawa · Full Face $99 Promo | Karine Lauzon RN",
    description: "Medical-grade chemical peels in Ottawa for glow, pigmentation, texture and acne. Full Face peel $99 (reg $150) for a limited time, back peels and packages of 4. Book online.",
  },
  "/eminence-facials": {
    description: "Éminence Organic facials in Ottawa from $69 — Express Glow $69, Signature Organic $119, Ultimate Organic with 15 minutes of LED $159, plus body rituals and add-ons. Fixed prices, book online.",
  },
};
